import { type Control, FieldPath, FieldValues } from 'react-hook-form';
import { TextAreaField } from '@brighte/form-components';
import { BENEFICIAL_OWNER_DETAILS } from '@utils';

type CorporateEntitiesFieldProps<TFieldValues extends FieldValues> = {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
};

function CorporateEntitiesField<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
}: CorporateEntitiesFieldProps<TFieldValues>) {
  const { CORPORATE_ENTITIES_LABEL, CORPORATE_ENTITIES_DESCRIPTION } = BENEFICIAL_OWNER_DETAILS;

  return (
    <TextAreaField
      name={name as FieldPath<TFieldValues>}
      control={control}
      label={CORPORATE_ENTITIES_LABEL}
      maxLength={255}
      FieldProps={{
        description: CORPORATE_ENTITIES_DESCRIPTION,
      }}
    />
  );
}

export default CorporateEntitiesField;
